import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=d321ff90&scoped=true&"
import script from "./stars.vue?vue&type=script&lang=js&"
export * from "./stars.vue?vue&type=script&lang=js&"
import style0 from "./stars.vue?vue&type=style&index=0&id=d321ff90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d321ff90",
  null
  
)

export default component.exports